// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"about-page_aboutWrapper__4mSdz","photo":"about-page_photo__AS9P+","textArea":"about-page_textArea__on6NP","header":"about-page_header__GnHE1"};